import { ShareBoxSocial, ShareBoxUl } from "./styles";
import ContentIcon from "@/shared/ContentIcon";
import FollowGoogle from "@/shared/FollowGoogle";

const ShareFooter = (props) => {
  return (
    <ShareBoxSocial>
      <ShareBoxUl>
        <li>
          <a
            href="https://www.facebook.com/clarincom/"
            target="_blank"
            aria-label="facebook"
          >
            <ContentIcon
              fill="#555"
              width="16.5px"
              height="17.5px"
              nameIcon="facebook"
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.twitter.com/clarincom/"
            target="_blank"
            aria-label="twitter"
          >
            <ContentIcon
              fill="#555"
              width="16.5px"
              height="17.5px"
              nameIcon="twitter"
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/company/clarin/?originalSubdomain=ar"
            target="_blank"
            aria-label="linkedin"
          >
            <ContentIcon
              fill="#555"
              width="16.5px"
              height="17.5px"
              nameIcon="linkedin-new"
            />
          </a>
        </li>
        <li>
          <a
            href="https://instagram.com/clarincom?igshid=ZWQyN2ExYTkwZQ=="
            target="_blank"
            aria-label="instagram"
          >
            <ContentIcon
              fill="#555"
              width="16.5px"
              height="17.5px"
              nameIcon="instagram"
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.tiktok.com/@clarincom?_t=8dDYO9is1TC&_r=1"
            target="_blank"
            aria-label="tiktok"
          >
            <ContentIcon
              fill="#555"
              width="16.5px"
              height="17.5px"
              nameIcon="tiktok"
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.youtube.com/@clarincom"
            target="_blank"
            aria-label="youtube"
          >
            <ContentIcon
              fill="#555"
              width="16.5px"
              height="17.5px"
              nameIcon="youtube"
            />
          </a>
        </li>
      </ShareBoxUl>
      <FollowGoogle
        className={`btn_logo_google ${props.className ? props.className : ""}`}
        icon
        text="Seguinos en"
        logoGoogle
      />
    </ShareBoxSocial>
  );
};

export default ShareFooter;
